export const API_RULE = "/api/xvat/rule";
export const API_RULE_SEARCH = "/api/xvat/ruleSearch";
export const API_RULE_SET = "/api/xvat/ruleSet";
export const API_RULE_SET_SEARCH = "/api/xvat/ruleSetSearch";
export const API_RULE_COLLECTION = "/api/xvat/ruleCollection";
export const API_RULE_COLLECTION_SEARCH = "/api/xvat/ruleCollectionSearch";
export const API_XPATH_MAPPING = "/api/xvat/xPath";
export const API_XPATH_ALL_MAPPING = "/api/xvat/getAllXpathMappings";
export const API_TEST_VALIDATION_RULE = "/api/xvat/testValidationRule";
export const API_TEST_VALIDATION_RULE_SET = "/api/xvat/testValidationRuleSet";
export const API_TEST_VALIDATION_RULE_COLLECTION =
  "/api/xvat/testValidationRuleCollection";
export const API_TEST_TRANSFORMATION_RULE = "/api/xvat/testTransformationRule";
export const API_VALIDATE_XML = "/api/xvat/validateXML";
export const API_TEST_TRANSFORMATION_JS_RULE = "/api/xvat/transformByJs";
export const API_TEST_TRANSFORMATION_RULE_SET =
  "/api/xvat/testTransformationRuleSet";
export const API_TEST_TRANSFORMATION_RULE_COLLECTION =
  "/api/xvat/testTransformationRuleCollection";
export const API_PROVIDER_CONFIGURATION =
  "/api/providers/providerConfiguration";

export const RULE_TYPE_VALIDATION = "VALIDATION";
export const RULE_TYPE_TRANSFORMATION = "TRANSFORMATION";
export const RULE_CAT_RULE = "rule";
export const RULE_CAT_RULE_SET = "ruleSet";
export const RULE_CAT_RULE_COLLECTION = "ruleCollection";



// WEBPACK FOOTER //
// ./src/XVAT/constants.js